import {createApp, defineAsyncComponent} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import './assets/main.css';
import mvcVueIntegration from "@/MvcVueIntegration.ts";
import VueCookies from 'vue-cookies';
import {openDeleteCompanyVerify} from '@/features/auth-verify/openDeleteCompanyVerify';
import {openTsdIdent} from '@/features/tsd/ident/openTsdIdent';
import {openPayoutCancellationPopup} from '@/features/tsd/cancellation/openPayoutCancellationPopup';
import {dismissById, dismissByTarget} from '@/features/announcements/dismissal';

const components = mvcVueIntegration.getComponents();

function mountVueComponent(element: HTMLElement) {
	if (element.dataset.vueMounted === 'true') return;

	const componentName = element.dataset.vueComponent;
	if (!componentName) {
		console.error('No component name specified for element:', element);
		return;
	}

	const componentOrLoader = components[componentName];
	if (!componentOrLoader) {
		console.error(`Vue component "${componentName}" not found.`);
		return;
	}

	const props = JSON.parse(element.dataset.props || '{}');

	const component = typeof componentOrLoader === 'function'
		? defineAsyncComponent(componentOrLoader as () => Promise<any>)
		: componentOrLoader;

	const app = createApp(component, props);
	const pinia = createPinia();
	pinia.use(piniaPluginPersistedstate);
	app.use(pinia);
	app.use(router);
	app.use(VueCookies);
	app.mount(element);
	element.dataset.vueMounted = 'true';
}

function mountVueComponentsIn(root: ParentNode = document) {
	root.querySelectorAll<HTMLElement>('[data-vue-component]').forEach(mountVueComponent);
}

window.mountVueComponents = mountVueComponentsIn;
window.openDeleteCompanyVerify = openDeleteCompanyVerify;
window.openTsdIdent = openTsdIdent;
window.openPayoutCancellationPopup = openPayoutCancellationPopup;

// Legacy JS has no way into this bundle, and an announcement outlives the view that raised it —
// so whatever resolves one has to be able to take it down from wherever it happens to be.
window.payroll_announcements = {dismiss: dismissById, dismissFor: dismissByTarget};

mountVueComponentsIn();
